import apiFetch from '../../apiFetch'

export default function (service, token, lastAccessDate) {
  return apiFetch({ endPoint: 'dossier/service', method: 'POST', body: service, token: token, lastAccessDate })
}
